<p-iconField iconPosition="left" class="ml-auto" style="width: 99%;">
  <p-inputIcon>
      <i class="pi pi-search"></i>
  </p-inputIcon>
  <input pInputText [(ngModel)]="chantFilter.searchStr" id="searchStr"
  (keyup.enter)="searchData()" type="text" placeholder="Search keyword"
  style="width: 99%; height: 45px;" />
</p-iconField>
